import styled from 'styled-components';
import { colorPrimary } from '../../theme';

export const Container = styled.div<{ $fullScreen?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
    flex-direction: column;
	height: ${({ $fullScreen }) => ($fullScreen ? 'calc(100vh - 200px)' : '64px')};

	.loader {
		width: 40px;
		height: 30px;
		display: grid;
	}
	.loader:before,
	.loader:after {
		content: '';
		grid-area: 1/1;
		background-color: ${colorPrimary};
		clip-path: polygon(
			0 10px,
			calc(100% - 15px) 10px,
			calc(100% - 15px) 0,
			100% 50%,
			calc(100% - 15px) 100%,
			calc(100% - 15px) calc(100% - 10px),
			0 calc(100% - 10px)
		);
		animation: l4 0.5s infinite alternate;
	}
	.loader:after {
		--s: -1;
	}
	.loaderText {
		margin-bottom: 20px;
	}
	@keyframes l4 {
		0% {
			transform: scale(var(--s, 1)) translate(12px, -6px) translate(4px);
		}
		100% {
			transform: scale(var(--s, 1)) translate(12px, -6px) translate(-4px);
		}
	}
`;
